const TrophyIcon = ({ className = "text-primary" }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9054 25.1494L15.3849 17.2227H12.207L13.7275 25.1494C14.1814 27.5077 15.4425 29.6343 17.2941 31.1637C19.1457 32.6931 21.4722 33.5298 23.8737 33.5301C24.4027 33.5284 24.9306 33.4826 25.4519 33.3932C23.3514 33.0675 21.4029 32.1006 19.873 30.6249C18.3431 29.1492 17.3066 27.2368 16.9054 25.1494Z"
        fill="currentColor"
      />
      <path
        d="M20.0977 17.2371H12.3511L13.8788 25.1638C14.3328 27.5195 15.5934 29.6434 17.4438 31.1703C19.2942 32.6971 21.6188 33.5316 24.0178 33.5301C26.4194 33.5298 28.7459 32.6931 30.5975 31.1637C32.4491 29.6343 33.7102 27.5077 34.164 25.1494L35.6845 17.2227H31.3608"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0178 33.5298V42.6744"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6748 42.6743H31.3681"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.1584 19.9897H41.5863C41.5863 19.9897 41.2909 28.0966 36.8663 30.9647"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8412 19.9897H6.41333C6.41333 19.9897 6.70158 28.0966 11.1333 30.9647"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0178 6.75928L26.2661 11.3135L31.2888 12.0414L27.6569 15.5868L28.5144 20.595L24.0178 18.2314L19.5284 20.595L20.3859 15.5868L16.7468 12.0414L21.7695 11.3135L24.0178 6.75928Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4925 8.33736L16.9343 5.3252"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M29.2424 8.33736L31.7934 5.3252"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </svg>
  );
};

export default TrophyIcon;
